import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > Math.max(320, window.innerHeight * 0.6));
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith("/owner")) return null;

  const goTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={goTop}
      aria-label="Back to top"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      data-testid="back-to-top-button"
      data-visible={visible ? "true" : "false"}
      style={{ bottom: "max(1rem, env(safe-area-inset-bottom))" }}
      className={`no-print fixed right-4 z-40 flex h-10 w-10 items-center justify-center rounded-full bg-plum/90 text-white shadow-md backdrop-blur transition-all duration-300 motion-reduce:transition-none hover:-translate-y-0.5 hover:bg-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 sm:right-6 sm:bottom-6 sm:h-11 sm:w-11 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <ArrowUp aria-hidden="true" className="h-4 w-4 sm:h-5 sm:w-5" strokeWidth={2.5} />
    </button>
  );
}
